<div style="width:100%; position:absolute; top:0px; height: 65px; ; left: 0px">
        <overlay-header [showCloseButton]="true" (closeClick)="closeClick()">
                <span *ngIf="loginSettings.V10 || loginSettings.EnableMyReports == false">My Reports</span>
                <span *ngIf="loginSettings.EnableMyReports == true">All Reports</span>
        </overlay-header>
</div>


<div *ngIf="isMyReports" style="height:100%; overflow:auto; background-color: #ffffff">
        <myReports (expandAllFolders)="expandAllFoldersClick($event)"></myReports>
</div>

<div *ngIf="isAllReports" style="height:100%; overflow:auto; background-color: #ffffff">
        <allReports></allReports>
</div>

<div>
        <reportFooter [callByV9MyReports]="callByV9MyReports" (expandAllFolders)="expandAllFoldersClick($event)"
                (refreshedReportFolders)="reportFoldersRefreshed($event)"></reportFooter>
</div>